import AddIcon from '@mui/icons-material/Add';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
    alpha,
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    Stack,
    styled,
    Switch,
    Tooltip,
    tooltipClasses,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { green } from '@mui/material/colors';
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/en-gb';
import React, { useEffect, useRef, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useLocation, useParams } from 'react-router-dom';
import { addToHistory } from '../../components/history';
import { appointmentDetails } from '../../redux/appointment/action';
import { calendarListing, getAppointmentCalendarPrefrences, getAvailablity, updateAvailablity } from '../../redux/Calendar/action';
import AppointmentModel from '../Appointment/AppointmentModel';
import ViewUpcomingModal from '../Appointment/UpcomingAppointment/ViewUpcomingModal';
import AddOdoModal from '../modal/AddOdoModal';
import AppointmentHoverDialog from './AppointmentHoverDialog';
import './Calendar.css';
import CalendarSettingModel from './CalendarSettingModel';
import CustomCalendar from './CustomCalendar';
import Sidebar from './Sidebar';
import { toast } from 'sonner';
import { useQueryClient } from '@tanstack/react-query';
import { coreSettingsKeys } from '../../services/core/settings';
const localizer = momentLocalizer(moment);

//test
const borderColor = (status) => {
    if (status == 'waiting_for_drop_off') return '8px solid #75DBFF';
    else if (status == 'vehicle_dropped_off') return '8px solid #FFC30F';
    else if (status == 'in_progress') return '8px solid #FF9E31';
    else if (status == 'ready_for_pick_up') return '8px solid #5CE469';
    else if (status == 'customer_paid') return '8px solid #00CD44';
    else return '8px solid #F44336';
};
const OtherSideBorderColor = (status) => {
    if (status == 'waiting_for_drop_off') return '2px solid #75DBFF';
    else if (status == 'vehicle_dropped_off') return '2px solid #FFC30F';
    else if (status == 'in_progress') return '2px solid #FF9E31';
    else if (status == 'ready_for_pick_up') return '2px solid #5CE469';
    else if (status == 'customer_paid') return '2px solid #00CD44';
    else return '2px solid #F44336';
};
const backgroundColor = (status) => {
    if (status == 'waiting_for_drop_off') return '#C1EFFF';
    else if (status == 'vehicle_dropped_off') return '#FFF0C2';
    else if (status == 'in_progress') return '#FFE6CB';
    else if (status == 'ready_for_pick_up') return '#F0F0F0';
    else if (status == 'customer_paid') return '#CEFFDE';
    else return '#FDE2E0';
};
const CustomMonthHeader = ({ label }) => (
    <div className="custom-month-header">
        <Typography variant="body1">{label}</Typography>
    </div>
);

const CustomWeekHeader = ({ label }) => {
    return (
        <div className="custom-week-header">
            <p>{label.split(' ')[1]}</p>
            <span style={{ fontSize: '22px' }}>{label.split(' ')[0]}</span>
            <div style={{ fontSize: '12px' }}>
                <Switch defaultChecked size="small" />
                Turn off availablity
            </div>
        </div>
    );
};
const CustomDayHeader = ({ props, availablity, currentDate, fetchAvailablityStatus, setShowLoader }) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const weekday = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    const date = new Date(props?.date).getDate();
    const day = weekday[new Date(props?.date).getDay()];
    const comingDate = moment(currentDate).format('YYYY-MM-DD');
    const [switchValue, setSwitchValue] = useState(availablity.filter((d) => d.date == moment(currentDate).format('YYYY-MM-DD'))?.length == 0 ? true : false);

    const updateStatusAvailablity = async (payload) => {
        setShowLoader(true);
        const resp = await dispatch(updateAvailablity(payload));

        if (resp) {
            queryClient.invalidateQueries({ queryKey: coreSettingsKeys.config(), refetchType: 'all' });
            // Also invalidate the disabled slots list
            queryClient.invalidateQueries({
                queryKey: coreSettingsKeys.slotsWithDisabled.all(),
                exact: false, // Invalidate all queries that start with this key
                refetchType: 'all',
            });
            // Also invalidate the disabled slots list
            queryClient.invalidateQueries({
                queryKey: coreSettingsKeys.disabledSlotsList(),
                refetchType: 'all',
            });
            // Invalidate available dates queries since disabling slots might affect date availability
            queryClient.invalidateQueries({
                queryKey: coreSettingsKeys.availableDates.all(),
                exact: false,
                refetchType: 'all',
            });
            fetchAvailablityStatus();
        }
    };

    return (
        <div className="custom-day-header">
            <div>{day}</div>
            <div>
                <h3>{date}</h3>
            </div>
            <div style={{ fontSize: '12px' }}>
                <RedSwitch
                    checked={availablity.filter((d) => d.date == moment(currentDate).format('YYYY-MM-DD'))?.length == 0 ? true : false}
                    onChange={(e) => {
                        updateStatusAvailablity({
                            shopId: JSON.parse(localStorage.getItem('apex-saas_details'))?._id,
                            date: comingDate,
                            isTurnOff: !e.target.checked,
                        });
                    }}
                />
                Appointment Requests :{switchValue ? 'ON' : 'OFF'}
            </div>
        </div>
    );
};

const RedSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: green[800],
        '&:hover': {
            backgroundColor: alpha(green[800], theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: green[800],
    },
}));

function MyCalendar() {
    const { calendarView } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [view, setView] = useState(calendarView ?? 'month');
    const [resources, setResources] = useState([]);
    const [calendarPreferences, setCalendarPreferences] = useState([
        'upcoming_appointments',
        'waiting_for_drop_off',
        'vehicle_dropped_off',
        'in_progress',
        'ready_for_pick_up',
    ]);
    const location = useLocation();
    const [date, setDate] = useState(new Date());
    const [sideBarWidth, setSideBarWidth] = useState(3);
    const [assignee, setAssignee] = useState([]);
    const [show, setShow] = React.useState(false);
    const [selectId, setSelectId] = React.useState('');
    const [updateStatus, setUpdateStatus] = React.useState('');
    const [appointmentDropOffODO, setAppointmentDropOffODo] = useState(null);
    const [appointmentCompletionOffODO, setAppointmentCompletionOffODo] = useState(null);

    const [customCalendarDates, setCustomCalendarDates] = useState({
        start: '',
        end: '',
    });
    const [calendarParams, setCalendarParams] = useState({
        startDate: moment(date).format('YYYY-MM-DD'),
        endDate: moment(date).format('YYYY-MM-DD'),
        assignee: [],
    });
    const [openAppointmentDetailModal, setOpenAppointmentDetailModal] = useState(false);
    const [appointmentDetailData, setAppointmentDetailData] = useState({});
    const [selectedAppointmentId, setSelectedAppointmentId] = useState('');
    const [events, setEvents] = useState([]);
    const [calendarDataApicallFirstTime, setCalendarDataApiCallFirstTime] = useState(false);
    const [upcomingAppointmentModel, setUpcomingAppointmentModel] = useState(false);
    const [dataLoader, setDataLoader] = useState(true);
    const [statusLoader, setStatusLoader] = useState(true);
    const [openCalendarSettings, setOpencalendarSettings] = useState(false);

    // Hover dialog state for day/month views
    const [hoverDialog, setHoverDialog] = useState({
        open: false,
        appointment: null,
        position: { x: 0, y: 0 },
    });

    // Timeout ref for mouse leave delay
    const mouseLeaveTimeoutRef = useRef(null);
    const measuredDialogHeightRef = useRef(null);
    const lastTriggerRectRef = useRef(null);
    const currentHoveredAppointmentRef = useRef(null);

    const OFFSET = 8;
    const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
    const computeFixedPosition = (rect, dialogWidth, dialogHeight) => {
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        let y;
        if (spaceBelow >= dialogHeight + OFFSET) {
            y = rect.bottom + OFFSET;
        } else if (spaceAbove >= dialogHeight + OFFSET) {
            y = rect.top - dialogHeight - OFFSET;
        } else {
            const idealBelow = rect.bottom + OFFSET;
            y = clamp(idealBelow, 8, window.innerHeight - dialogHeight - 8);
        }

        let x = rect.left + rect.width / 2 - dialogWidth / 2;
        x = clamp(x, 8, window.innerWidth - dialogWidth - 8);
        return { x, y };
    };

    useEffect(() => {
        const currentDate = new Date(date);
        const currentDayOfWeek = currentDate.getDay();

        if (view == '3day') {
            const startDate = new Date(currentDate);
            startDate.setDate(currentDate.getDate());

            const endDate = new Date(currentDate);
            endDate.setDate(currentDate.getDate() + 2);

            fetchCalendarData({
                startDate: moment(startDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
                assignee: [],
            });
        }
        if (view == '5day') {
            const startDate = new Date(currentDate);
            startDate.setDate(currentDate.getDate());

            const endDate = new Date(currentDate);
            endDate.setDate(currentDate.getDate() + 4);

            fetchCalendarData({
                startDate: moment(startDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
                assignee: [],
            });
        }
    }, [view, date, resources, calendarPreferences]);

    const fetchCalendarDataonAppointmentStatusChange = () => {
        handleCloseAppointmentDetailModal();
        fetchCalendarData(calendarParams);
    };

    const handleViewChange = (newView) => {
        setView(newView);
    };

    const handleTodayClick = () => {
        setDate(new Date());
    };

    const handleNavigate = (action) => {
        let numberOfDays = '';
        let type = '';
        if (view == 'day') {
            type = 'day';
            numberOfDays = 1;
        }
        if (view == '3day') {
            type = 'day';
            numberOfDays = 3;
        }
        if (view == '5day') {
            type = 'day';
            numberOfDays = 5;
        }

        if (view == 'month') {
            type = 'month';
            numberOfDays = 1;
        }
        const newDate = action === 'PREV' ? moment(date).subtract(numberOfDays, type) : moment(date).add(numberOfDays, type);

        setDate(newDate.toDate());
    };

    const handleCloseUpcomingAppointmentModal = () => {
        setUpcomingAppointmentModel(false);
        setSelectedAppointmentId('');
        fetchCalendarDataonAppointmentStatusChange();
    };

    const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: 'transparent',
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[0],
            fontSize: 11,
        },
    }));

    const CustomEvent = ({ event }) => {
        return (
            <Stack
                sx={{
                    margin: '2px 0 2px 0px',
                    cursor: 'pointer',
                    height: 'calc(100% - 4px)',
                    overflow: 'hidden',
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    handleMouseLeave();
                    setSelectedAppointmentId(event?.appointmentId);
                }}
                onMouseEnter={(e) => {
                    e.stopPropagation();
                    const appointmentData = {
                        title: event?.title,
                        customer: event?.customer,
                        services: event?.services || [],
                        start: event?.start,
                        status: event?.status,
                        appointmentId: event?.appointmentId,
                        vehicle: event?.vehicle,
                        noteForCustomer: event?.noteForCustomer,
                        note: event?.note,
                    };
                    handleMouseEnter(e, appointmentData);
                }}
                onMouseLeave={(e) => {
                    e.stopPropagation();
                    handleMouseLeave();
                }}
            >
                <Typography style={{ fontWeight: '600', fontSize: '16px' }}>
                    {dayjs(event?.start).format('h:mm a') + ' - '}
                    {event?.customer?.firstName}
                    {'  '}
                    {event?.customer?.lastName}
                </Typography>
                <Typography style={{ fontWeight: '400', fontSize: '14px' }}>Drop Off:{moment(event.start).format('h:mm a')}</Typography>
                <Typography style={{ fontWeight: '400', fontSize: '14px' }}>{event?.service}</Typography>
            </Stack>
        );
    };

    useEffect(() => {
        if (resources.length > 0 && view != '3day' && view != '5day') {
            calendarParams.startDate = moment(new Date(date)).format('YYYY-MM-DD');
            calendarParams.endDate = moment(new Date(date)).format('YYYY-MM-DD');
            fetchCalendarData(calendarParams);
        }
        if (view != 'month') fetchAvailablityStatus();
        else {
            setStatusLoader(false);
        }
    }, [resources, date, view, calendarPreferences]);

    useEffect(() => {
        fetchAppointmentsStatusList();
    }, []);

    const fetchCalendarData = async (calendarParams) => {
        if (calendarDataApicallFirstTime) {
            let payload = {
                ...calendarParams,
                calendarViewPreferences: [],
            };
            if (resources?.length == 0) {
                return;
            }
            if (view == 'month') {
                var y = date.getFullYear();
                var m = date.getMonth();
                var startDate = new Date(y, m, 1);
                var endDate = new Date(y, m + 1, 0);
                payload.startDate = moment(startDate).format('YYYY-MM-DD');
                payload.endDate = moment(endDate).format('YYYY-MM-DD');
                payload.assignee = [];
            }
            resources?.map((assign) => {
                payload.assignee.push(assign?._id);
            });
            calendarPreferences?.map((preferance) => {
                payload.calendarViewPreferences.push(preferance);
            });
            setCalendarParams(payload);
            setDataLoader(true);
            const resp = await dispatch(calendarListing(payload));

            let data = [];
            Array.isArray(resp) &&
                resp?.map((r) => {
                    data.push({
                        title: r?.data?.appointmentNumber,
                        start: moment(r?.start).toDate(),
                        end: moment(r?.end).toDate(),
                        resourceId: r?.data?.assignee?._id,
                        services: r?.data?.services,
                        customer: r?.data?.customer,
                        appointmentId: r?.data?._id,
                        status: r?.data?.status,
                        vehicle: r?.data?.vehicle,
                        noteForCustomer: r?.data?.noteForCustomer,
                        note: r?.data?.note,
                    });
                });
            setEvents(data);
            setDataLoader(false);
        }
    };

    const fetchAvailablityStatus = async () => {
        setStatusLoader(true);
        await dispatch(getAvailablity());
        setStatusLoader(false);
    };

    useEffect(() => {
        const loader = dataLoader || statusLoader;
        setShowLoader(loader);
    }, [dataLoader, statusLoader]);

    const availablity = useSelector((state) => state.calendar.availablity);

    const fetchAppointmentsStatusList = async () => {
        setShowLoader(true);
        await dispatch(getAppointmentCalendarPrefrences());
        setShowLoader(false);
        setCalendarDataApiCallFirstTime(true);
    };

    const appointmentsStatusList = useSelector((state) => state.calendar.appointmentsStatus);

    useEffect(() => {
        if (Object.keys(appointmentsStatusList).length > 0) {
            const trueKeys = [];
            const dataObj = {
                ...appointmentsStatusList,
            };

            for (let key in dataObj) {
                if (dataObj.hasOwnProperty(key) && dataObj[key] === true) {
                    trueKeys.push(key);
                }
            }
            setCalendarPreferences(trueKeys);
        }
    }, [appointmentsStatusList]);

    useEffect(() => {
        details();
    }, [selectedAppointmentId]);

    const details = async () => {
        if (selectedAppointmentId) {
            setShowLoader(true);
            const detailView = await dispatch(appointmentDetails(selectedAppointmentId));

            let timeOfAppointment = dayjs(detailView?.dropOffDateTime).format('YYYY-MM-DD');

            setShowLoader(false);
            if (detailView) {
                setAppointmentDetailData(detailView);

                const currentDate = dayjs().format('YYYY-MM-DD');

                if (dayjs(timeOfAppointment).isAfter(currentDate)) {
                    setUpcomingAppointmentModel(true);
                } else {
                    if (detailView?.status === 'customer_paid' || detailView?.status === 'mark_as_no_show') {
                        navigate(`/appointment/past-appointment/${detailView?._id}`);
                    } else {
                        setOpenAppointmentDetailModal(true);
                    }
                }
            }
        }
    };

    useEffect(() => {
        navigate(`/calendar/${view}`);
    }, [view]);

    const handleCloseAppointmentDetailModal = () => {
        setOpenAppointmentDetailModal(false);
        setSelectedAppointmentId('');
    };

    const CustomMonthEvent = ({ event }) => (
        <div
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
                e.stopPropagation();
                handleMouseLeave();
                setSelectedAppointmentId(event?.appointmentId);
            }}
            onMouseEnter={(e) => {
                e.stopPropagation();
                const appointmentData = {
                    title: event?.title,
                    customer: event?.customer,
                    services: event?.services || [],
                    start: event?.start,
                    status: event?.status,
                    appointmentId: event?.appointmentId,
                    vehicle: event?.vehicle,
                    noteForCustomer: event?.noteForCustomer,
                    note: event?.note,
                };
                handleMouseEnter(e, appointmentData);
            }}
            onMouseLeave={(e) => {
                e.stopPropagation();
                handleMouseLeave();
            }}
        >
            <Typography fontWeight={600}>
                {dayjs(event?.start).format('h:mm a') + ' - '}
                {event?.customer?.firstName}
                {'  '}
                {event?.customer?.lastName}
            </Typography>
        </div>
    );

    const handleStatusClose = () => {
        setShow(false);
    };

    const handleStatus = () => setShow(true);

    // Hover handlers for day/month views
    const handleMouseEnter = (event, appointment) => {
        // Prevent repeated triggers for the same appointment
        if (currentHoveredAppointmentRef.current === appointment.appointmentId) {
            return;
        }

        // Clear any pending timeout
        if (mouseLeaveTimeoutRef.current) {
            clearTimeout(mouseLeaveTimeoutRef.current);
            mouseLeaveTimeoutRef.current = null;
        }

        // Update current hovered appointment
        currentHoveredAppointmentRef.current = appointment.appointmentId;

        const rect = event.currentTarget.getBoundingClientRect();
        lastTriggerRectRef.current = rect;

        const dialogWidth = 300;
        const dialogHeight = measuredDialogHeightRef.current ?? 370;
        const { x, y } = computeFixedPosition(rect, dialogWidth, dialogHeight);

        setHoverDialog({ open: true, appointment: appointment, position: { x, y } });
    };

    const handleMouseLeave = () => {
        // Add delay before closing to allow mouse to move to dialog
        mouseLeaveTimeoutRef.current = setTimeout(() => {
            setHoverDialog((prev) => ({ ...prev, open: false }));
            currentHoveredAppointmentRef.current = null;
        }, 150);
    };

    const handleDialogMouseEnter = () => {
        // Clear timeout when mouse enters dialog
        if (mouseLeaveTimeoutRef.current) {
            clearTimeout(mouseLeaveTimeoutRef.current);
            mouseLeaveTimeoutRef.current = null;
        }
    };

    const handleDialogMouseLeave = () => {
        // Close dialog when mouse leaves dialog
        if (hoverDialog.open) {
            setHoverDialog((prev) => ({ ...prev, open: false }));
            currentHoveredAppointmentRef.current = null;
        }
    };

    const handleCloseHoverDialog = () => {
        // Clear timeout and close dialog
        if (mouseLeaveTimeoutRef.current) {
            clearTimeout(mouseLeaveTimeoutRef.current);
            mouseLeaveTimeoutRef.current = null;
        }
        setHoverDialog((prev) => ({ ...prev, open: false }));
        currentHoveredAppointmentRef.current = null;
    };

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (mouseLeaveTimeoutRef.current) {
                clearTimeout(mouseLeaveTimeoutRef.current);
            }
        };
    }, []);

    return (
        <>
            <Box sx={{ padding: '32px 24px', width: '100%' }}>
                <Box mb={4}>
                    <div className="my-custom-toolbar">
                        <Grid container columns={16} sx={{ bgcolor: 'background.main' }}>
                            <Grid xl={4} lg={3} md={4}>
                                <Typography display={'inline'} className="toolbar-label" fontSize={'34px'}>
                                    {moment(date).format('MMMM YYYY')}
                                </Typography>
                            </Grid>
                            <Grid display={'flex'} alignItems="center" xl={4} lg={5} md={4}>
                                <IconButton
                                    onClick={(e) => {
                                        handleNavigate('PREV');
                                    }}
                                >
                                    <ChevronLeftIcon />
                                </IconButton>
                                <IconButton onClick={() => handleNavigate('NEXT')}>
                                    <ChevronRightIcon />
                                </IconButton>
                                <Button onClick={handleTodayClick} variant="contained" color="primary" size="large">
                                    Today
                                </Button>
                            </Grid>
                            <Grid xl={8} lg={8} md={8} sm={10}>
                                <Stack spacing={2} direction="row" sx={{ float: 'right' }}>
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            onClick={() => {
                                                setOpencalendarSettings(true);
                                            }}
                                        >
                                            Settings
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            size="large"
                                            startIcon={<AddIcon />}
                                            onClick={() => {
                                                addToHistory(location.pathname);
                                                navigate('/appointment/new-appointment');
                                            }}
                                        >
                                            New Appointment
                                        </Button>
                                    </div>
                                </Stack>
                            </Grid>
                        </Grid>
                    </div>
                </Box>
                <div className="calendar-app">
                    <Grid container columns={20}>
                        <Grid xl={sideBarWidth} lg={sideBarWidth + 1} md={sideBarWidth + 2} sm={sideBarWidth} xs={sideBarWidth}>
                            <Sidebar
                                view={view}
                                setView={setView}
                                setSideBarWidth={setSideBarWidth}
                                sideBarWidth={sideBarWidth}
                                setResources={setResources}
                                resources={resources}
                                setAssignee={setAssignee}
                                calendarPreferences={calendarPreferences}
                                setCalendarPreferences={setCalendarPreferences}
                            />
                        </Grid>
                        <Grid xl={20 - sideBarWidth} lg={20 - sideBarWidth - 1} md={20 - sideBarWidth - 2} sm={20 - sideBarWidth} xs={20 - sideBarWidth}>
                            {view == 'day' || view == 'month' ? (
                                <div className="calendar-container" onMouseLeave={handleDialogMouseLeave}>
                                    <Calendar
                                        localizer={localizer}
                                        events={events}
                                        showAllEvents={true}
                                        selectable={true}
                                        onSelectEvent={(event) => {
                                            setSelectedAppointmentId(event?.appointmentId);
                                        }}
                                        onSelectSlot={(e) => {
                                            setView('day');
                                            setDate(e?.start);
                                        }}
                                        startAccessor="start"
                                        endAccessor="end"
                                        components={{
                                            month: {
                                                header: CustomMonthHeader,
                                                event: CustomMonthEvent,
                                                dateHeader: (e) => {
                                                    const isToday = moment(e?.date).isSame(moment(), 'day');
                                                    return isToday ? (
                                                        <span
                                                            style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: '32px',
                                                                height: '32px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#006CDD',
                                                                color: '#fff',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                lineHeight: 1,
                                                            }}
                                                        >
                                                            {e.label}
                                                        </span>
                                                    ) : (
                                                        <span
                                                            style={{
                                                                fontSize: '13.33px',
                                                                color: e?.isOffRange ? '#9e9e9e' : 'inherit',
                                                                display: 'inline-block',
                                                                padding: '2px 4px',
                                                            }}
                                                        >
                                                            {e.label}
                                                        </span>
                                                    );
                                                },
                                            },
                                            work_week: {
                                                header: CustomWeekHeader,
                                            },
                                            day: {
                                                toolbar: (props) => (
                                                    <CustomDayHeader
                                                        props={props}
                                                        availablity={availablity}
                                                        currentDate={date}
                                                        fetchAvailablityStatus={fetchAvailablityStatus}
                                                        setShowLoader={setShowLoader}
                                                    />
                                                ),
                                                event: CustomEvent,
                                                resourceHeader: (props) => <Chip label={props?.resource?.title} className="customCalendarChip"></Chip>,
                                            },
                                        }}
                                        step={30}
                                        resources={
                                            view == 'work_week'
                                                ? resources.length == 1
                                                    ? [...resources]
                                                    : false
                                                : resources.length > 0
                                                  ? [...resources]
                                                  : false
                                        }
                                        view={view}
                                        defaultView={view}
                                        onView={handleViewChange}
                                        views={['day', 'work_week', 'month', 'week']}
                                        date={date}
                                        timeslots={2}
                                        onNavigate={handleNavigate}
                                        min={new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate(), 0, 0, 0)}
                                        formats={{ timeGutterFormat: 'h:mm A' }}
                                        eventPropGetter={(myEventsList) => {
                                            return {
                                                style: {
                                                    backgroundColor: backgroundColor(myEventsList?.status),
                                                    borderLeft: borderColor(myEventsList?.status),
                                                    borderRight: OtherSideBorderColor(myEventsList?.status),
                                                    borderTop: OtherSideBorderColor(myEventsList?.status),
                                                    borderBottom: OtherSideBorderColor(myEventsList?.status),
                                                },
                                            };
                                        }}
                                        dayPropGetter={() => {
                                            return { style: { background: 'none' } };
                                        }}
                                        scrollToTime={new Date()}
                                    />
                                </div>
                            ) : (
                                <CustomCalendar
                                    date={date}
                                    resources={resources}
                                    view={view}
                                    events={events}
                                    setCustomCalendarDates={setCustomCalendarDates}
                                    availablity={availablity}
                                    fetchAvailablityStatus={fetchAvailablityStatus}
                                    setSelectedAppointmentId={setSelectedAppointmentId}
                                    setShowLoader={setShowLoader}
                                    showLoader={showLoader}
                                />
                            )}
                        </Grid>
                    </Grid>
                </div>
            </Box>

            {/* Hover Dialog for day/month views */}
            {hoverDialog.open && (
                <AppointmentHoverDialog
                    open={hoverDialog.open}
                    onClose={handleCloseHoverDialog}
                    appointment={hoverDialog.appointment}
                    position={hoverDialog.position}
                    onMouseEnter={handleDialogMouseEnter}
                    onMouseLeave={handleDialogMouseLeave}
                    onMeasureHeight={(h) => {
                        if (!h || !lastTriggerRectRef.current) return;
                        // Store measured height for future hovers
                        measuredDialogHeightRef.current = h;
                        // Recompute once with actual height, update if changed
                        const { x, y } = computeFixedPosition(lastTriggerRectRef.current, 300, h);
                        setHoverDialog((prev) => ({ ...prev, position: { x, y } }));
                    }}
                />
            )}

            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            <AppointmentModel
                open={openAppointmentDetailModal}
                handleClose={handleCloseAppointmentDetailModal}
                data={appointmentDetailData}
                status={appointmentDetailData?.status}
                show={show}
                handleStatusClose={handleStatusClose}
                handleStatus={handleStatus}
                recallDetailsAPI={() => {
                    details();
                }}
                setUpdateStatus={setUpdateStatus}
                setSelectId={setSelectId}
                setAppointmentCompletionOffODo={setAppointmentCompletionOffODo}
                setAppointmentDropOffODo={setAppointmentDropOffODo}
                fetchCalendarDataonAppointmentStatusChange={fetchCalendarDataonAppointmentStatusChange}
            />
            {(appointmentDetailData?.status == 'waiting_for_drop_off' ||
                appointmentDetailData?.status == 'in_progress' ||
                appointmentDetailData?.status == 'vehicle_dropped_off') && (
                <AddOdoModal
                    open={show}
                    handleClose={() => setShow(false)}
                    updateStatus={updateStatus}
                    id={selectId}
                    handleClose1={() => setShow(false)}
                    currentStatus={appointmentDetailData?.status}
                    handleClose2={() => setShow(false)}
                    appointmentDropOffODO={appointmentDropOffODO}
                    appointmentCompletionOffODO={appointmentCompletionOffODO}
                    setAppointmentCompletionOffODo={setAppointmentCompletionOffODo}
                    setAppointmentDropOffODo={setAppointmentDropOffODo}
                    appointmentView={() => {}}
                    fetchCalendarDataonAppointmentStatusChange={fetchCalendarDataonAppointmentStatusChange}
                />
            )}
            <ViewUpcomingModal
                handleClose={handleCloseUpcomingAppointmentModal}
                open={upcomingAppointmentModel}
                handleCancelModel={handleCloseUpcomingAppointmentModal}
                upcomingData={appointmentDetailData}
                appointmentId={selectedAppointmentId}
                fromCaledner
                fetchAppointmentDetails={details}
                recallDetailsAPI={() => {
                    details();
                }}
            />
            <CalendarSettingModel open={openCalendarSettings} handleCloseModel={() => setOpencalendarSettings(false)} />
        </>
    );
}

export default MyCalendar;
